<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <v-row dense>
    <v-col cols="12">
      <v-card class="pa-2" outlined tile height="100%">
        <v-tabs v-model="tab">
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(item, i) in items" :key="item">
              <v-data-table
                :headers="headers"
                :items="i === 0 ? providers : inactive"
                sort-by="Name"
                sort-asc
                :loading="isLoading"
                loading-text="Loading Providers"
                :search="search"
                height="550"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Providers</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      clearable
                      flat
                      solo-inverted
                      hide-details
                      prepend-inner-icon="search"
                      label="search"
                      class="desktop"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="100%">
                      <template v-slot:activator="{ on }">
                        <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()" v-if="canUpdate"
                          >
                          <v-icon left>add</v-icon>
                          Add Provider</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title style="background-color: #2b3990">
                          <span class="headline white--text">{{ titleForm  }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            ref="form"
                            lazy-validation>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="newName"
                                    label="Provider Name"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="newEmail"
                                    label="Email"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-autocomplete
                                    v-model="newProfession"
                                    label="Profession"
                                    :items="roles"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    label="Phone Number"
                                    v-model="newPhone"
                                    v-mask="'(###) ###-####'"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    label="Fax"
                                    v-model="newFax"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="newCompany"
                                    label="Facility"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="6">
                                  <v-text-field
                                    v-model="newAddress"
                                    label="Address"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="newCity"
                                    label="City"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="4">
                                  <v-select
                                    v-model="newState"
                                    label="State"
                                    :items="state"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-select>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="newZip"
                                    label="Zip"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                    :rules="requiredField"
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                  <v-switch
                                    :label="isStatusActive ? 'Active' : 'Inactive'"
                                    v-model="isStatusActive"
                                    :readonly="!canUpdate"
                                    :disabled="!canUpdate"
                                  ></v-switch>
                                </v-col>

                                <!-- <v-col class="d-flex" cols="12" sm="12" md="4">
                                  <v-select
                                    v-model="newClient"
                                    label="Client"
                                    :items="clients"
                                    item-text="Name"
                                    item-value="_id"
                                    @change="log"
                                    multiple
                                  ></v-select>
                                </v-col> -->
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="white--text" color="#259647" @click="addProvider()" v-if="newProvider" :readonly="!canUpdate"
                                  :disabled="!canUpdate">Save</v-btn
                          >
                          <v-btn color="blue darken-1" text @click="updateProvider()" v-if="editProvider" :readonly="!canUpdate"
                                  :disabled="!canUpdate">Update</v-btn
                          >
                          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="mobile ml-5 mr-5 mb-3 mt-3"
                  ></v-text-field>
                </template>

              <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="viewProvider(item)">
                    mdi-eye
                  </v-icon>
                  <!-- <v-icon small class="mr-2" @click="editProvider(item)">
                    mdi-pencil
                  </v-icon> -->
                  <v-icon small @click="deleteProvider(item)" v-if="canUpdate">
                    mdi-delete
                  </v-icon>
                  <!-- <v-icon small @click="addDeal(item)">
                    add
                  </v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="#2b3990" class="white--text" @click="getProviders()">Reset</v-btn>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
      </v-card>
    </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import Foot from '../../components/Footer'

const url = require("../../client_config/config").url;

export default {
  components: {
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Provider Name',
          align: 'start',
          value: 'Name',
        },
        { text: "Email", value: "Email" },
        { text: "Profession", value: "Profession" },
        { text: "Phone Number", value: "Phone" },
        { text: "Facility", value: "Company" },
        { text: "Address", value: "Address" },
        { text: "City", value: "City" },
        { text: "State", value: "State" },
        { text: "Zip", value: "Zip" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      editProvider: false,
      newProvider: false,
      tab: null,
      items: [
        "Active Providers",
        "Inactive Providers"
      ],
      msg: false,
      search: "",
      text:"",
      providers: [],
      inactive: [],
      units: [],
      codes: [],
      tempData: [],
      clients: [],
      unitID: localStorage.getItem('unitID'),
      clientID: localStorage.getItem('clientId'),
      titleForm: "New Provider",
      providerID: "",
      newName: "",
      newEmail: "",
      newProfession: "",
      newCompany: "",
      newPhone: "",
      newFax: "",
      newAddress: "",
      newCity: "",
      newState: "",
      newZip: "",
      newStatus: "",
      isStatusActive: true,
      newClient: "",
      requiredField: [
          v => !!v || 'This is required',
      ],
      isLoading: true,
      roles: [
        "Admitting Physician",
        "Allergist", 
        "Appointed Attorney", 
        "Attending Physician", 
        "Appointed Attorney",
        "Audiologist", 
        "Behaviorist", 
        "Cardiologist", 
        "Care Worker Supervisor", 
        "Case Worker",
        "Chiropractor", 
        "Counselor/Therapist",
        "Dentist", 
        "Dermatologist", 
        "Ears, Nose and Throat (ENT)",
        "Emergency Room", 
        "Employer", 
        "Endocrinologist",
        "Gastroenterologist", 
        "Gynecologist",
        "Hospital", 
        "Legal Guardian",
        "Nephrologist", 
        "Neurologist", 
        "Nurse", 
        "Nurse Practitioner", 
        "Nutritionist/Dietician",
        "Occupational Therapist",
        "Oncologist",
        "Optometrist/Ophthalmologist",
        "Orthopedic", 
        "Parent (Connect Access)", 
        "Pharmacy", 
        "Phlebotomist",
        "Physical Therapist", 
        "Physician or Specialist", 
        "Physician Assistant",
        "Podiatrist", 
        "Primary Care MD", 
        "Psychiatrist", 
        "Public Guardian", 
        "Radiologist",
        "Sleep Specialist",
        "Support Coordinator", 
        "Surgeon",
        "Urologist", 
        "Urgent Care", 
        "Work Site",
        "Wound Care"
      ],
      state: ["Utah", "Nevada"]
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    canUpdate(){
      if(localStorage.getItem("userRole") == "Administration"
        || localStorage.getItem("userRole") == "Program Coordinator"
        || localStorage.getItem("userRole") == "Compliance Manager"
        || localStorage.getItem("userRole") == "Human Resources"
        || localStorage.getItem("userRole") == "Client Services Manager"
        || localStorage.getItem("userRole") == "Medical Manager"
      ){
        return true;
      }

      return false;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    isStatusActive: {
      immediate: true,
      handler(val) {
        this.newStatus = val ? "Active" : "Inactive";
      }
    },
  },

  created() {
    this.getProviders();
    this.getClients();

    this.newStatus = this.isStatusActive ? "Active" : "Inactive";
  },

  methods: {
    validate() {
        return this.$refs.form[0].validate();
    },

    validateUpdate() {
        return this.$refs.formUpdate.validate();
    },

    validateReset() {
        if (this.$refs.form != undefined) {
            this.$refs.form.reset();
        }
    },
    initialize() {
      this.providers = [];
    },
    viewProvider(item) {
      this.titleForm= "Viewing " + item.Name;
      this.dialog = true;
      this.editProvider = true;
      this.newProvider = false;
      this.newName = item.Name;
      this.newEmail = item.Email;
      this.newProfession = item.Profession;
      this.newCompany = item.Company;
      this.newPhone = item.Phone;
      this.newFax = item.Fax;
      this.newAddress = item.Address;
      this.newCity = item.City;
      this.newState = item.State;
      this.newZip = item.Zip;
      this.newStatus = item.Status;
      this.providerID = item._id;

      this.newState = this.newState == "NV" ? "Nevada" : this.newState
      this.isStatusActive = this.newStatus == "Active" ? true : false;
    },
    showAdd() {
      this.titleForm= "New Provider";
      this.newProvider = true;
      this.editProvider = false;
      this.validateReset()
    },

    deleteProvider(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this provider?") &&
      this.providerDelete(id);

    },

    providerDelete(id) {
      axios.delete(`${url}/providers/${id}`)
      .then((response) => {
        this.getProviders();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The provider has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateProvider() {
      var req_body = {
        Name: this.newName,
        Email: this.newEmail,
        Profession: this.newProfession,
        Company: this.newCompany,
        Phone: this.newPhone,
        Fax: this.newFax,
        Address: this.newAddress,
        City: this.newCity,
        State: this.newState,
        Zip: this.newZip,
        Status: this.newStatus,
      };
      axios.put(`${url}/providers/${this.providerID}`, req_body).then((response) => {
        this.getProviders();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.newName= "";
        this.newEmail = "";
        this.newProfession = "";
        this.newCompany = "";
        this.newPhone = "";
        this.newFax = "";
        this.newAddress = "";
        this.newCity = "";
        this.newState = "";
        this.newZip = "";
        this.newStatus = "";
        this.msg=true;
        this.text="The provider has been updated successfully.";
      });
      this.close();
    },
    getProviders: function() {
      this.isLoading = true;
      axios.get(`${url}/providers/status`).then(res => {
        this.providers = res.data.Active
        this.inactive = res.data.Inactive
      }).finally(() => this.isLoading = false);
    },

    getClients(){
        axios.get(`${url}/clients`).then(res => {
            this.clients = res.data.clients
        })
    },

    addProvider: function() {
      if(this.validate()){
        var req_body = {
        Name: this.newName,
        Email: this.newEmail,
        Profession: this.newProfession,
        Company: this.newCompany,
        Phone: this.newPhone,
        Fax: this.newFax,
        Address: this.newAddress,
        City: this.newCity,
        State: this.newState,
        Zip: this.newZip,
        Status: this.newStatus,
        ClientID: this.newClient,
      };

      axios.post(`${url}/providers`, req_body ).then(res => {
        this.getProviders();
        if (res.status == 400) {
          res.json().then(function(data) {
            this.text=data.msg;
          });
        }
        this.newName = "";
        this.newEmail = "";
        this.newProfession = "";
        this.newCompany = "";
        this.newPhone = "";
        this.newFax = "";
        this.newAddress = "";
        this.newCity = "";
        this.newState = "";
        this.newZip = "";
        this.newStatus = "";
        this.msg=true;
        this.text="The new provider has been added successfully.";
      });
      this.close();
      }
      
    },

    log() {
        console.log(this.newClient)
    }
  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }
</style>